import { render, staticRenderFns } from "./nosePunchingBetweenTwoDays.vue?vue&type=template&id=451aad9e&scoped=true&"
import script from "./nosePunchingBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./nosePunchingBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451aad9e",
  null
  
)

export default component.exports